<template>
  <v-navigation-drawer 
    v-model="open" 
    :width="width"
    :right="right"
    fixed
    :temporary="temporary"
    stateless
    touchless
    class="leftsidebar"
    :class="{ boxshadow: open }"    
    >
    
    <v-flex class="sbTitle">
        
        <v-toolbar :dark = dark :color="toolbarColor">                   
                    <v-toolbar-title 
                        class="headline">               
                        <slot name="sbTitle"></slot>
                    </v-toolbar-title>                                            
                    <v-spacer></v-spacer>
                    <v-tooltip v-if="actionIcon4" nudge-bottom="50">
                        <v-btn icon @click="actionFunction4" slot="activator">
                            <v-icon>{{actionIcon4}}</v-icon>
                        </v-btn>
                        <span>{{actionTooltip4}}</span>
                    </v-tooltip>
                    <v-tooltip v-if="actionIcon3" nudge-bottom="50">
                        <v-btn icon @click="actionFunction3" slot="activator">
                            <v-icon>{{actionIcon3}}</v-icon>
                        </v-btn>
                        <span>{{actionTooltip3}}</span>
                    </v-tooltip>
                    <v-tooltip v-if="actionIcon2" nudge-bottom="50">
                        <v-btn icon @click="actionFunction2" slot="activator">
                            <v-icon>{{actionIcon2}}</v-icon>
                        </v-btn>
                        <span>{{actionTooltip2}}</span>
                    </v-tooltip>
                    <v-tooltip v-if="actionIcon" nudge-bottom="50">
                        <v-btn icon @click="actionFunction" slot="activator">
                            <v-icon>{{actionIcon}}</v-icon>
                        </v-btn>
                        <span>{{actionTooltip}}</span>
                    </v-tooltip>
                    <v-btn icon @click="updateSidebar(false)">
                        <v-icon v-if="right">chevron_right</v-icon>
                        <v-icon v-if="!right">chevron_left</v-icon>
                    </v-btn>
        </v-toolbar>
        <v-progress-linear class="mt-0" v-if="loading" color="blue" indeterminate></v-progress-linear>
    </v-flex>

    <v-flex class="sbContent">
        <slot name="sbContent"></slot>
    </v-flex>

  </v-navigation-drawer>
</template>

<script>

    let LeftSidebar = {

        props: [ 'open', 'width', 'updateSidebar', 'dark', 'right', 'actionFunction', 'actionIcon', 'actionFunction2', 'actionIcon2', 'toolbarColor', 'loading', 'temporary', 'actionTooltip', 'actionTooltip2',
            'actionIcon3','actionFunction3', 'actionTooltip3', 'actionIcon4','actionFunction4', 'actionTooltip4' ]

    } 

    export default LeftSidebar
</script>

<style>

.leftsidebar {
    top: 70px !important;
    height: calc(100vh - 70px) !important;    
    z-index: 30 !important;
    overflow: hidden !important; 
  }

.boxshadow {
    box-shadow: -6px 6px 40px -14px #000;
}

.sbTitle
{
    height:50px;
}

.sbContent
{
    position:absolute;
    top: 64px;
    padding-bottom: 10px;
    left:0px;
    right:0px;
    bottom:0px;
    overflow-y:auto;
    overflow-x:hidden;       
}

</style>



// WEBPACK FOOTER //
// src/components/LeftSidebar.vue